import React, { useState } from "react";
import { resetUserPassword } from "../../utils/api";

function ResetPasswordModal({ show, onClose, userId, refresh, setBanner }) {
  const [password, setPassword] = useState("");
  const [forceChange, setForceChange] = useState(false);

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await resetUserPassword(userId, password, forceChange);

      if (res.success) {
        setBanner({
          type: "success",
          message: res.message || "Password reset successfully!",
        });
        setPassword("");
        setForceChange(false);
        refresh();
        onClose();
      } else {
        setBanner({
          type: "danger",
          message: res.message || "Error resetting password. Please try again.",
        });
      }
    } catch (err) {
      console.error("Reset password error:", err);
      setBanner({
        type: "danger",
        message: "Server error while resetting password.",
      });
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-info text-white">
            <h5 className="modal-title">Reset Password</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="forceChange"
                  checked={forceChange}
                  onChange={(e) => setForceChange(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="forceChange">
                  Require user to change password on next login
                </label>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-success">
                  Reset
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordModal;
